class BundleDiscount extends HTMLElement {
  constructor() {
    super();
    this.sectionId = this.dataset.sectionId;
    this.cartUpdateUnsubscriber = undefined;
    
    this.init();
  }
  
  init() {
    this.bindEvents();
  }
  
  bindEvents() {
    // Usar el sistema de pub/sub del tema
    if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
      this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
        this.updateBundleSection();
      });
    }
    
    // Fallback para eventos personalizados
    document.addEventListener('cart:updated', () => this.updateBundleSection());
    document.addEventListener('cart:changed', () => this.updateBundleSection());
  }
  
  connectedCallback() {
    // Método del ciclo de vida del web component
  }
  
  disconnectedCallback() {
    // Limpiar suscripciones cuando el componente se desconecte
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }
  
  getSectionsToRender() {
    return [
      {
        id: `bundle-discount-${this.sectionId}`,
        section: `collection-bundle`,
        selector: 'bundle-discount'
      }
    ];
  }
  
  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }
  
  updateBundleSection() {
    console.log('Updating bundle section via Sections API');
    
    const body = JSON.stringify({
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: body
    })
    .then((response) => {
      return response.text();
    })
    .then((state) => {
      const parsedState = JSON.parse(state);
      console.log('Bundle section update response:', parsedState);

      if (parsedState.errors) {
        console.error('Bundle section update errors:', parsedState.errors);
        return;
      }

      // Actualizar el contenido del bundle usando la respuesta de sections
      this.getSectionsToRender().forEach((section) => {
        const elementToReplace = document.getElementById(`bundle-discount-${this.sectionId}`);
        
        if (elementToReplace && parsedState.sections && parsedState.sections[section.section]) {
          const newHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
          
          if (newHTML) {
            elementToReplace.innerHTML = newHTML;
            console.log('Bundle section content updated successfully');
          }
        }
      });
    })
    .catch((error) => {
      console.error('Error updating bundle section:', error);
    });
  }
  
  // Método para aplicar descuento (se puede integrar con Shopify Scripts o Apps)
  applyBundleDiscount(discountPercentage) {
    const discountCode = `BUNDLE${discountPercentage}PERCENT`;
    
    // Ejemplo de aplicación de código de descuento
    fetch('/discount/' + discountCode, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      }
    }).then(response => {
      if (response.ok) {
        console.log('Descuento aplicado:', discountCode);
      }
    }).catch(error => {
      console.error('Error applying bundle discount:', error);
    });
  }
}

// Registrar el custom element
customElements.define('bundle-discount', BundleDiscount);

// Inicializar cuando el DOM esté listo
document.addEventListener('DOMContentLoaded', function() {
  // Asegurar que todos los bundle discounts se inicialicen correctamente
  const bundleDiscounts = document.querySelectorAll('bundle-discount');
  bundleDiscounts.forEach(discount => {
    if (!discount.initialized) {
      discount.initialized = true;
    }
  });
});
